import React from "react";
// import "bootstrap-icons/font/bootstrap-icons.css";

const TermsOfService = () => {
  return (
    <div>
 
      <section className="section-padding-100">
        <div className="container">

          <div className="privacy-content">

            <h4>1. Acceptance of Terms</h4>
            <p>
              By accessing and using the services of Finbasket, you agree to comply 
              with and be bound by these Terms of Service. If you do not agree 
              with any part of these terms, you should not use our website or services.
            </p>

            <h4>2. Services Offered</h4>
            <p>
              Finbasket provides assistance in applying for loans through partner 
              banks and NBFCs. We act as a facilitator and do not directly lend money. 
              Loan approval, interest rates, tenure, and disbursement are subject 
              to the policies and final decision of the respective financial institution.
            </p>

            <h4>3. Eligibility</h4>
            <p>
              By using our services, you confirm that you are at least 18 years old 
              and legally capable of entering into a binding agreement. You agree 
              to provide accurate, complete, and up-to-date information during the 
              loan application process.
            </p>

            <h4>4. User Responsibilities</h4>
            <p>
              You are responsible for maintaining the confidentiality of your 
              personal information and ensuring that all documents submitted are 
              genuine and valid. Any false or misleading information may result in 
              rejection of your application and possible legal action.
            </p>

            <h4>5. Fees & Charges</h4>
            <p>
              Finbasket may charge service or processing fees where applicable. 
              Any such charges will be clearly communicated before proceeding. 
              Additional fees such as interest, penalties, or foreclosure charges 
              are determined by the respective bank or NBFC.
            </p>

            <h4>6. Limitation of Liability</h4>
            <p>
              Finbasket shall not be held liable for loan rejections, delays in 
              processing, changes in interest rates, or any decisions made by 
              partner financial institutions. We are not responsible for any 
              financial losses arising from the use of our services.
            </p>

            <h4>7. Intellectual Property</h4>
            <p>
              All content, branding, logos, text, graphics, and materials on this 
              website are the property of Finbasket and are protected by applicable 
              intellectual property laws. Unauthorized use or reproduction is strictly prohibited.
            </p>

            <h4>8. Termination of Services</h4>
            <p>
              Finbasket reserves the right to suspend or terminate access to its 
              services at any time without prior notice if a user violates these 
              terms or engages in fraudulent or unlawful activities.
            </p>

            <h4>9. Governing Law</h4>
            <p>
              These Terms of Service shall be governed by and interpreted in 
              accordance with the laws of India. Any disputes arising shall be 
              subject to the jurisdiction of the appropriate courts in India.
            </p>

            <h4>10. Modifications to Terms</h4>
            <p>
              Finbasket reserves the right to update or modify these Terms of 
              Service at any time. Continued use of the website following any 
              changes constitutes acceptance of the revised terms.
            </p>

            <h4>11. Contact Information</h4>
            <p>
              For any questions regarding these Terms of Service, please contact 
              us through our official Contact Us page.
            </p>

          </div>

        </div>
      </section>

      <style>{`
        .privacy-content h4 {
          margin-top: 25px;
          font-weight: 600;
        }

        .privacy-content p {
          margin-top: 10px;
          line-height: 1.7;
          color: #555;
        }

        .badge {
          background-color: #1fa5a9;
          padding: 8px 15px;
          font-size: 14px;
        }
      `}</style>

    </div>
  );
};

export default TermsOfService;
